import React from "react";
import { Controller } from "react-hook-form";
import "./RadioButtonGroup.css";

const RadioButtonGroup = ({
  options,
  name,
  control,
  errors, // ADDED: Accept errors prop
  parentLabel,
  mandatory,
  isBankFieldDisable,
  edit,
  makeRadioButtonForBranchUserDisable,
  isCurrentUserAdmin,
}) => {
  console.log("Received Parent Label:", parentLabel);
  console.log("Received Options:", options);
  console.log("Name:", name);
  console.log("Errors:", errors); // ADDED: Debug errors

  // ADDED: Extract error for this field
  const error = errors && errors[name];
  console.log(`Error for ${name}:`, error);

  if (!options || !Array.isArray(options)) {
    console.error("Options is not defined or not an array:", options);
    return (
      <div className="radio-group-container">
        {parentLabel && (
          <label className="radio-parent-label" style={{ color: "white" }}>
            {parentLabel}
            {mandatory && <span className="mandatory-asterisk"> *</span>}
          </label>
        )}
        <div>No options available</div>
      </div>
    );
  }

  return (
    <div className="radio-group-container">
      {parentLabel && (
        <label className="radio-parent-label" style={{ color: "black" }}>
          {parentLabel}
          {mandatory && <span className="mandatory-asterisk"> *</span>}
        </label>
      )}
      <div className="radio-group div-space-adminrole">
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, value } }) => (
            <>
              {options.map((option) => (
                <label key={option.value} className="radio-container">
                  <span className="dynamic__radio--label label-adminrole">
                    {option.label}
                  </span>
                  <input
                    className={`radio-adminrole ${error ? "radio-error" : ""}`} // ADDED: Error class
                    type="radio"
                    value={option.value}
                    checked={value === option.value}
                    onChange={(e) => onChange(e.target.value)}
                    disabled={
                      isBankFieldDisable ||
                      edit ||
                      makeRadioButtonForBranchUserDisable ||
                      isCurrentUserAdmin
                    }
                  />
                </label>
              ))}
            </>
          )}
        />
      </div>

      {/* ADDED: Error message display */}
      {error && <div className="radio-error-message">{error.message}</div>}
    </div>
  );
};

export default RadioButtonGroup;
